const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartAdd: 'cart-add',
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


const eu_countries = [
  {
    name: "Avstrija",
    code: "AT"
  },
  {
    name: "Belgija",
    code: "BE"
  },
  {
    name: "Bolgarija",
    code: "BG"
  },
  {
    name: "Ciper",
    code: "CY"
  },
  {
    name: "Češka",
    code: "CZ"
  },
  {
    name: "Danska",
    code: "DK"
  },
  {
    name: "Estonija",
    code: "EE"
  },
  {
    name: "Finska",
    code: "FI"
  },
  {
    name: "Francija",
    code: "FR"
  },
  {
    name: "Grčija",
    code: "GR"
  },
  {
    name: "Hrvaška",
    code: "HR"
  },
  {
    name: "Irska",
    code: "IE",
    provinces: [
      {
        name: "Carlow",
        code: "CW"
      },
      {
        name: "Cavan",
        code: "CN"
      },
      {
        name: "Clare",
        code: "CE"
      },
      {
        name: "Cork",
        code: "CO"
      },
      {
        name: "Donegal",
        code: "DL"
      },
      {
        name: "Dublin",
        code: "D"
      },
      {
        name: "Galway",
        code: "G"
      },
      {
        name: "Kerry",
        code: "KY"
      },
      {
        name: "Kildare",
        code: "KE"
      },
      {
        name: "Kilkenny",
        code: "KK"
      },
      {
        name: "Laois",
        code: "LS"
      },
      {
        name: "Leitrim",
        code: "LM"
      },
      {
        name: "Limerick",
        code: "LK"
      },
      {
        name: "Longford",
        code: "LD"
      },
      {
        name: "Louth",
        code: "LH"
      },
      {
        name: "Mayo",
        code: "MO"
      },
      {
        name: "Meath",
        code: "MH"
      },
      {
        name: "Monaghan",
        code: "MN"
      },
      {
        name: "Offaly",
        code: "OY"
      },
      {
        name: "Roscommon",
        code: "RN"
      },
      {
        name: "Sligo",
        code: "SO"
      },
      {
        name: "Tipperary",
        code: "TA"
      },
      {
        name: "Waterford",
        code: "WD"
      },
      {
        name: "Westmeath",
        code: "WH"
      },
      {
        name: "Wexford",
        code: "WX"
      },
      {
        name: "Wicklow",
        code: "WW"
      }
    ]
  },
  {
    name: "Italija",
    code: "IT",
    provinces: [
      {
        name: "Agrigento",
        code: "AG"
      },
      {
        name: "Alessandria",
        code: "AL"
      },
      {
        name: "Ancona",
        code: "AN"
      },
      {
        name: "Aosta",
        code: "AO"
      },
      {
        name: "Arezzo",
        code: "AR"
      },
      {
        name: "Ascoli Piceno",
        code: "AP"
      },
      {
        name: "Asti",
        code: "AT"
      },
      {
        name: "Avellino",
        code: "AV"
      },
      {
        name: "Bari",
        code: "BA"
      },
      {
        name: "Barletta-Andria-Trani",
        code: "BT"
      },
      {
        name: "Belluno",
        code: "BL"
      },
      {
        name: "Benevento",
        code: "BN"
      },
      {
        name: "Bergamo",
        code: "BG"
      },
      {
        name: "Biella",
        code: "BI"
      },
      {
        name: "Bologna",
        code: "BO"
      },
      {
        name: "Bolzano",
        code: "BZ"
      },
      {
        name: "Brescia",
        code: "BS"
      },
      {
        name: "Brindisi",
        code: "BR"
      },
      {
        name: "Cagliari",
        code: "CA"
      },
      {
        name: "Caltanissetta",
        code: "CL"
      },
      {
        name: "Campobasso",
        code: "CB"
      },
      {
        name: "Carbonia-Iglesias",
        code: "CI"
      },
      {
        name: "Caserta",
        code: "CE"
      },
      {
        name: "Catania",
        code: "CT"
      },
      {
        name: "Catanzaro",
        code: "CZ"
      },
      {
        name: "Chieti",
        code: "CH"
      },
      {
        name: "Como",
        code: "CO"
      },
      {
        name: "Cosenza",
        code: "CS"
      },
      {
        name: "Cremona",
        code: "CR"
      },
      {
        name: "Crotone",
        code: "KR"
      },
      {
        name: "Cuneo",
        code: "CN"
      },
      {
        name: "Enna",
        code: "EN"
      },
      {
        name: "Fermo",
        code: "FM"
      },
      {
        name: "Ferrara",
        code: "FE"
      },
      {
        name: "Firenze",
        code: "FI"
      },
      {
        name: "Foggia",
        code: "FG"
      },
      {
        name: "Forlì-Cesena",
        code: "FC"
      },
      {
        name: "Frosinone",
        code: "FR"
      },
      {
        name: "Genova",
        code: "GE"
      },
      {
        name: "Gorizia",
        code: "GO"
      },
      {
        name: "Grosseto",
        code: "GR"
      },
      {
        name: "Imperia",
        code: "IM"
      },
      {
        name: "Isernia",
        code: "IS"
      },
      {
        name: "L'Aquila",
        code: "AQ"
      },
      {
        name: "La Spezia",
        code: "SP"
      },
      {
        name: "Latina",
        code: "LT"
      },
      {
        name: "Lecce",
        code: "LE"
      },
      {
        name: "Lecco",
        code: "LC"
      },
      {
        name: "Livorno",
        code: "LI"
      },
      {
        name: "Lodi",
        code: "LO"
      },
      {
        name: "Lucca",
        code: "LU"
      },
      {
        name: "Macerata",
        code: "MC"
      },
      {
        name: "Mantova",
        code: "MN"
      },
      {
        name: "Massa-Carrara",
        code: "MS"
      },
      {
        name: "Matera",
        code: "MT"
      },
      {
        name: "Medio Campidano",
        code: "VS"
      },
      {
        name: "Messina",
        code: "ME"
      },
      {
        name: "Milano",
        code: "MI"
      },
      {
        name: "Modena",
        code: "MO"
      },
      {
        name: "Monza e Brianza",
        code: "MB"
      },
      {
        name: "Napoli",
        code: "NA"
      },
      {
        name: "Novara",
        code: "NO"
      },
      {
        name: "Nuoro",
        code: "NU"
      },
      {
        name: "Ogliastra",
        code: "OG"
      },
      {
        name: "Olbia-Tempio",
        code: "OT"
      },
      {
        name: "Oristano",
        code: "OR"
      },
      {
        name: "Padova",
        code: "PD"
      },
      {
        name: "Palermo",
        code: "PA"
      },
      {
        name: "Parma",
        code: "PR"
      },
      {
        name: "Pavia",
        code: "PV"
      },
      {
        name: "Perugia",
        code: "PG"
      },
      {
        name: "Pesaro e Urbino",
        code: "PU"
      },
      {
        name: "Pescara",
        code: "PE"
      },
      {
        name: "Piacenza",
        code: "PC"
      },
      {
        name: "Pisa",
        code: "PI"
      },
      {
        name: "Pistoia",
        code: "PT"
      },
      {
        name: "Pordenone",
        code: "PN"
      },
      {
        name: "Potenza",
        code: "PZ"
      },
      {
        name: "Prato",
        code: "PO"
      },
      {
        name: "Ragusa",
        code: "RG"
      },
      {
        name: "Ravenna",
        code: "RA"
      },
      {
        name: "Reggio Calabria",
        code: "RC"
      },
      {
        name: "Reggio Emilia",
        code: "RE"
      },
      {
        name: "Rieti",
        code: "RI"
      },
      {
        name: "Rimini",
        code: "RN"
      },
      {
        name: "Roma",
        code: "RM"
      },
      {
        name: "Rovigo",
        code: "RO"
      },
      {
        name: "Salerno",
        code: "SA"
      },
      {
        name: "Sassari",
        code: "SS"
      },
      {
        name: "Savona",
        code: "SV"
      },
      {
        name: "Siena",
        code: "SI"
      },
      {
        name: "Siracusa",
        code: "SR"
      },
      {
        name: "Sondrio",
        code: "SO"
      },
      {
        name: "Taranto",
        code: "TA"
      },
      {
        name: "Teramo",
        code: "TE"
      },
      {
        name: "Terni",
        code: "TR"
      },
      {
        name: "Torino",
        code: "TO"
      },
      {
        name: "Trapani",
        code: "TP"
      },
      {
        name: "Trento",
        code: "TN"
      },
      {
        name: "Treviso",
        code: "TV"
      },
      {
        name: "Trieste",
        code: "TS"
      },
      {
        name: "Udine",
        code: "UD"
      },
      {
        name: "Varese",
        code: "VA"
      },
      {
        name: "Venezia",
        code: "VE"
      },
      {
        name: "Verbano-Cusio-Ossola",
        code: "VB"
      },
      {
        name: "Vercelli",
        code: "VC"
      },
      {
        name: "Verona",
        code: "VR"
      },
      {
        name: "Vibo Valentia",
        code: "VV"
      },
      {
        name: "Vicenza",
        code: "VI"
      },
      {
        name: "Viterbo",
        code: "VT"
      }
    ]
  },
  {
    name: "Latvija",
    code: "LV"
  },
  {
    name: "Litva",
    code: "LT"
  },
  {
    name: "Luksemburg",
    code: "LU"
  },
  {
    name: "Madžarska",
    code: "HU"
  },
  {
    name: "Malta",
    code: "MT"
  },
  {
    name: "Nemčija",
    code: "DE"
  },
  {
    name: "Nizozemska",
    code: "NL"
  },
  {
    name: "Poljska",
    code: "PL"
  },
  {
    name: "Portugalska",
    code: "PT",
    provinces: [
      {
        name: "Açores",
        code: "PT-20"
      },
      {
        name: "Aveiro",
        code: "PT-01"
      },
      {
        name: "Beja",
        code: "PT-02"
      },
      {
        name: "Braga",
        code: "PT-03"
      },
      {
        name: "Bragança",
        code: "PT-04"
      },
      {
        name: "Castelo Branco",
        code: "PT-05"
      },
      {
        name: "Coimbra",
        code: "PT-06"
      },
      {
        name: "Évora",
        code: "PT-07"
      },
      {
        name: "Faro",
        code: "PT-08"
      },
      {
        name: "Guarda",
        code: "PT-09"
      },
      {
        name: "Leiria",
        code: "PT-10"
      },
      {
        name: "Lisboa",
        code: "PT-11"
      },
      {
        name: "Madeira",
        code: "PT-30"
      },
      {
        name: "Portalegre",
        code: "PT-12"
      },
      {
        name: "Porto",
        code: "PT-13"
      },
      {
        name: "Santarém",
        code: "PT-14"
      },
      {
        name: "Setúbal",
        code: "PT-15"
      },
      {
        name: "Viana do Castelo",
        code: "PT-16"
      },
      {
        name: "Vila Real",
        code: "PT-17"
      },
      {
        name: "Viseu",
        code: "PT-18"
      }
    ]
  },
  {
    name: "Romunija",
    code: "RO",
    provinces: [
      {
        name: "Alba",
        code: "AB"
      },
      {
        name: "Arad",
        code: "AR"
      },
      {
        name: "Argeș",
        code: "AG"
      },
      {
        name: "Bacău",
        code: "BC"
      },
      {
        name: "Bihor",
        code: "BH"
      },
      {
        name: "Bistrița-Năsăud",
        code: "BN"
      },
      {
        name: "Botoșani",
        code: "BT"
      },
      {
        name: "Brașov",
        code: "BV"
      },
      {
        name: "Brăila",
        code: "BR"
      },
      {
        name: "București",
        code: "B"
      },
      {
        name: "Buzău",
        code: "BZ"
      },
      {
        name: "Călărași",
        code: "CL"
      },
      {
        name: "Caraș-Severin",
        code: "CS"
      },
      {
        name: "Cluj",
        code: "CJ"
      },
      {
        name: "Constanța",
        code: "CT"
      },
      {
        name: "Covasna",
        code: "CV"
      },
      {
        name: "Dâmbovița",
        code: "DB"
      },
      {
        name: "Dolj",
        code: "DJ"
      },
      {
        name: "Galați",
        code: "GL"
      },
      {
        name: "Giurgiu",
        code: "GR"
      },
      {
        name: "Gorj",
        code: "GJ"
      },
      {
        name: "Harghita",
        code: "HR"
      },
      {
        name: "Hunedoara",
        code: "HD"
      },
      {
        name: "Iași",
        code: "IS"
      },
      {
        name: "Ialomița",
        code: "IL"
      },
      {
        name: "Ilfov",
        code: "IF"
      },
      {
        name: "Maramureș",
        code: "MM"
      },
      {
        name: "Mehedinți",
        code: "MH"
      },
      {
        name: "Mureș",
        code: "MS"
      },
      {
        name: "Neamț",
        code: "NT"
      },
      {
        name: "Olt",
        code: "OT"
      },
      {
        name: "Prahova",
        code: "PH"
      },
      {
        name: "Sălaj",
        code: "SJ"
      },
      {
        name: "Satu Mare",
        code: "SM"
      },
      {
        name: "Sibiu",
        code: "SB"
      },
      {
        name: "Suceava",
        code: "SV"
      },
      {
        name: "Teleorman",
        code: "TR"
      },
      {
        name: "Timiș",
        code: "TM"
      },
      {
        name: "Tulcea",
        code: "TL"
      },
      {
        name: "Vâlcea",
        code: "VL"
      },
      {
        name: "Vaslui",
        code: "VS"
      },
      {
        name: "Vrancea",
        code: "VN"
      }
    ]
  },
  {
    name: "Slovaška",
    code: "SK"
  },
  {
    name: "Španija",
    code: "ES",
    provinces: [
      {
        name: "A Coruña",
        code: "C"
      },
      {
        name: "Álava",
        code: "VI"
      },
      {
        name: "Albacete",
        code: "AB"
      },
      {
        name: "Alicante",
        code: "A"
      },
      {
        name: "Almería",
        code: "AL"
      },
      {
        name: "Asturias",
        code: "O"
      },
      {
        name: "Ávila",
        code: "AV"
      },
      {
        name: "Badajoz",
        code: "BA"
      },
      {
        name: "Balears",
        code: "PM"
      },
      {
        name: "Barcelona",
        code: "B"
      },
      {
        name: "Burgos",
        code: "BU"
      },
      {
        name: "Cáceres",
        code: "CC"
      },
      {
        name: "Cádiz",
        code: "CA"
      },
      {
        name: "Cantabria",
        code: "S"
      },
      {
        name: "Castellón",
        code: "CS"
      },
      {
        name: "Ceuta",
        code: "CE"
      },
      {
        name: "Ciudad Real",
        code: "CR"
      },
      {
        name: "Córdoba",
        code: "CO"
      },
      {
        name: "Cuenca",
        code: "CU"
      },
      {
        name: "Girona",
        code: "GI"
      },
      {
        name: "Granada",
        code: "GR"
      },
      {
        name: "Guadalajara",
        code: "GU"
      },
      {
        name: "Guipúzcoa",
        code: "SS"
      },
      {
        name: "Huelva",
        code: "H"
      },
      {
        name: "Huesca",
        code: "HU"
      },
      {
        name: "Jaén",
        code: "J"
      },
      {
        name: "La Rioja",
        code: "LO"
      },
      {
        name: "Las Palmas",
        code: "GC"
      },
      {
        name: "León",
        code: "LE"
      },
      {
        name: "Lleida",
        code: "L"
      },
      {
        name: "Lugo",
        code: "LU"
      },
      {
        name: "Madrid",
        code: "M"
      },
      {
        name: "Málaga",
        code: "MA"
      },
      {
        name: "Melilla",
        code: "ML"
      },
      {
        name: "Murcia",
        code: "MU"
      },
      {
        name: "Navarra",
        code: "NA"
      },
      {
        name: "Ourense",
        code: "OR"
      },
      {
        name: "Palencia",
        code: "P"
      },
      {
        name: "Pontevedra",
        code: "PO"
      },
      {
        name: "Salamanca",
        code: "SA"
      },
      {
        name: "Santa Cruz de Tenerife",
        code: "TF"
      },
      {
        name: "Segovia",
        code: "SG"
      },
      {
        name: "Sevilla",
        code: "SE"
      },
      {
        name: "Soria",
        code: "SO"
      },
      {
        name: "Tarragona",
        code: "T"
      },
      {
        name: "Teruel",
        code: "TE"
      },
      {
        name: "Toledo",
        code: "TO"
      },
      {
        name: "Valencia",
        code: "V"
      },
      {
        name: "Valladolid",
        code: "VA"
      },
      {
        name: "Vizcaya",
        code: "BI"
      },
      {
        name: "Zamora",
        code: "ZA"
      },
      {
        name: "Zaragoza",
        code: "Z"
      }
    ]
  },
  {
    name: "Švedska",
    code: "SE"
  }
]
